import React from 'react';
import { Cart } from '../../../../../../../model/Cart';
import { toCurrency } from 'src/helpers/currency/toCurrency';

interface ProductListUIProps {
  cartsProducts?: Cart[];
  totalAfterDiscount?: any;
}

export const ProductListUI: React.FC<ProductListUIProps> = ({
  cartsProducts,
  totalAfterDiscount,
}) => {
  if (!cartsProducts || cartsProducts.length === 0) {
    return (
      <div className="bg-white border border-gray-200 rounded-lg shadow-sm w-full">
        <div className="px-6 py-4 border-b border-gray-100">
          <h2 className="text-lg font-semibold text-gray-900">Carrinho</h2>
        </div>
        <div className="p-6">
          <p className="text-gray-500 text-center py-8 text-sm">
            Seu carrinho está vazio
          </p>
        </div>
      </div>
    );
  }

  const productsBySeller = cartsProducts.reduce<Record<string, Cart[]>>(
    (acc, cartItem) => {
      const sellerName =
        cartItem.products.storeSeller?.name || 'Vendedor desconhecido';
      if (!acc[sellerName]) {
        acc[sellerName] = [];
      }
      acc[sellerName].push(cartItem);
      return acc;
    },
    {}
  );

  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-sm w-full">
      <div className="px-6 py-4 border-b border-gray-100">
        <h2 className="text-lg font-semibold text-gray-900">Carrinho</h2>
      </div>

      <div className="p-6 space-y-6">
        {Object.entries(productsBySeller).map(([sellerName, products]) => (
          <div key={sellerName} className="space-y-4">
            <h3 className="text-sm font-semibold text-gray-700 border-b border-gray-100 pb-1">
              {sellerName}
            </h3>
            {products.map((cart, index) => (
              <div
                key={index}
                className="flex items-center gap-4 p-3 rounded-lg hover:bg-gray-50 transition-colors duration-200"
              >
                <div className="flex-shrink-0">
                  {cart.products.imagens?.[0] ? (
                    <img
                      src={cart.products.imagens[0]}
                      alt={cart.products.name}
                      className="w-16 h-16 object-cover rounded-lg border border-gray-200"
                    />
                  ) : (
                    <div className="w-16 h-16 bg-gray-100 rounded-lg border border-gray-200"></div>
                  )}
                </div>

                <div className="flex-1 min-w-0">
                  <h4 className="font-medium text-gray-900 text-sm mb-1 truncate">
                    {cart.products.name}
                  </h4>
                  <p className="text-xs text-gray-500 mb-2">
                    Quantidade: {cart.cartProduct.quantity}
                  </p>
                  <p className="font-semibold text-red-600 text-sm">
                    {toCurrency(cart.cartProduct.grade.price)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>

      <div className="px-6 py-4 bg-gray-50 rounded-b-lg border-t border-gray-100">
        <div className="flex justify-end">
          <a
            href="/carts"
            className="inline-flex items-center px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-medium rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
          >
            Ver Carrinho
          </a>
        </div>
      </div>
    </div>
  );
};
